import { useEffect, useRef } from "react";
import { CheckCircleOutlineIcon, ToastA11Y, ToastTiming, useToast } from "@viagogo/core/ui";
import { useContent } from "src/shared/components/content";
import { useSellerHubPriceRecommendation } from "src/website-apps/shared/components/header/listing-notification/SellerHubPriceRecommendationContext";

const PARAM_NAME = "showSurveyToast";

export const SurveySubmissionToast = () => {
  const { enqueueToast } = useToast();
  const message = useContent("cid$#3675182#"); // Thank you for your feedback!
  const toastDisplayed = useRef(false);
  const { shouldSuppressCompetingToasts } = useSellerHubPriceRecommendation();

  useEffect(() => {
    if (toastDisplayed.current || shouldSuppressCompetingToasts) return;

    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get(PARAM_NAME);

    if (paramValue === "true") {
      enqueueToast({
        content: message,
        timing: ToastTiming.long,
        a11y: ToastA11Y.passive,
        icon: CheckCircleOutlineIcon,
        showCloseIcon: true,
      });

      // Mark that we've shown the toast to prevent re-showing on re-renders
      toastDisplayed.current = true;

      // Remove the param from the URL to prevent re-showing if URL is shared/bookmarked
      urlParams.delete(PARAM_NAME);
      const newUrl = urlParams.toString()
        ? `${window.location.pathname}?${urlParams.toString()}`
        : window.location.pathname;
      window.history.replaceState({}, "", newUrl);
    }
  }, [enqueueToast, message, shouldSuppressCompetingToasts]);

  return null;
};
